import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createStatus: {
		id: 'business-summary.summary-view.progress-by-status.create-status-button.create-status',
		defaultMessage: 'Create status',
		description: 'Label of inline create status button',
	},
});
